import React, { useEffect } from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { captureAttributionOnVisit } from '../utils/attribution';

/**
 * /r/:token — referral link. Captures first-touch attribution then redirects to signup.
 */
export default function ReferralRedirect() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    captureAttributionOnVisit();
  }, []);

  const ref = token || '';
  const search = searchParams.toString();
  const to = search ? `/signup?ref=${encodeURIComponent(ref)}&${search}` : `/signup?ref=${encodeURIComponent(ref)}`;

  return <Navigate to={to} replace />;
}
